"use client";

import React, { useState } from "react";
import styles from "../css/SendReminder.module.css";

export default function SendReminder({ appointment, onClose }) {
  const [smsMsg, setSmsMsg] = useState("");
  const [emailSubject, setEmailSubject] = useState("");
  const [emailMsg, setEmailMsg] = useState("");
  if (!appointment) return null;
  const { patient } = appointment;

  const sendSMS = () => {
    // Mock send SMS
    onClose?.();
  };
  const sendEmail = () => {
    // Mock send Email
    onClose?.();
  };

  return (
    <div className={styles.overlay}>
      <div className={styles.modal}>
        <div className={styles.header}>
          <h3 className={styles.title}>Send Reminder to {patient?.name}</h3>
          <button className={styles.close} onClick={onClose}>×</button>
        </div>

        <div className={styles.columns}>
          <div className={styles.col}>
            <div className={styles.labelRow}><strong>SMS</strong>&nbsp;&nbsp;<span className={styles.addr}>{patient?.phone}</span></div>
            <textarea className={styles.textarea} placeholder="Type" value={smsMsg} onChange={(e) => setSmsMsg(e.target.value)} />
            <button className={styles.primary} onClick={sendSMS}>Send SMS</button>
          </div>
          <div className={styles.col}>
            <div className={styles.labelRow}><strong>Email</strong>&nbsp;&nbsp;<span className={styles.addr}>{patient?.email}</span></div>
            <input className={styles.input} placeholder="Add a Subject" value={emailSubject} onChange={(e) => setEmailSubject(e.target.value)} />
            <textarea className={styles.textarea} placeholder="Type" value={emailMsg} onChange={(e) => setEmailMsg(e.target.value)} />
            <button className={styles.primary} onClick={sendEmail}>Send Email</button>
          </div>
        </div>
      </div>
    </div>
  );
}

